export default __webpack_public_path__ + "static/media/contact-3.9226dea5.png";